// extracted by mini-css-extract-plugin
export default {"formThreshold":"ThresholdCreateForm_formThreshold__m84Gt","accionesThreshold":"ThresholdCreateForm_accionesThreshold__VRdEj"};